module.exports = __webpack_public_path__ + "img/BentonSansBBVA-MediumItalic.f96a65f4.svg";